import { User } from "@/models";
import { TableColumn } from "react-data-table-component";
import { EditUserButton } from "@/components/atoms";
import { UserTableCellWrapText } from "@/components/atoms/UserTableCellWrapText";

export const UsersTableColumns: TableColumn<User>[] = [
  {
    id: 5,
    name: "更新日",
    selector: (row) => row.formattedUpdatedAt(),
    sortable: true,
  },
  {
    id: 99,
    name: "ユーザーID",
    selector: (row) => row.username,
    sortable: true,
    cell: (row) => (
      <UserTableCellWrapText>{row.username}</UserTableCellWrapText>
    ),
  },
  {
    id: 1,
    name: "氏名",
    selector: (row) => row.fullName(),
    sortable: true,
    cell: (row) => (
      <UserTableCellWrapText>{row.fullName()}</UserTableCellWrapText>
    ),
  },
  {
    id: 2,
    name: "権限",
    selector: (row) => row.authorityDisplayName(),
    sortable: true,
  },
  {
    id: 4,
    name: "",
    cell: (row) => <EditUserButton sub={row.sub} />,
  },
];
